module.exports = __webpack_public_path__ + "static/media/image9.c8a879a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image9.jpg
// module id = 43
// module chunks = 0